module.exports = __webpack_public_path__ + "Roboto-Light.37fbbbad5577a95bdf05.woff";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Light.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Light.woff
// module chunks = 5